import { cls } from '@/ui/cls'
interface Props {
  score: number  // 0-100
  size?: number
}

const TIER_COLOR = {
  high: 'text-ink-1000',
  mid:  'text-clay',
  low:  'text-ink-300',
} as const

export default function ScoreRing({ score, size = 36 }: Props) {
  const r = (size - 4) / 2
  const c = 2 * Math.PI * r
  const off = c * (1 - score / 100)
  const tier: keyof typeof TIER_COLOR = score >= 85 ? 'high' : score >= 65 ? 'mid' : 'low'
  return (
    <div
      className={cls('relative inline-grid place-items-center', TIER_COLOR[tier])}
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="var(--color-ink-100)" strokeWidth="2" fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          strokeWidth="2"
          fill="none"
          stroke="currentColor"
          strokeDasharray={c}
          strokeDashoffset={off}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className="absolute font-mono text-[11px] font-semibold text-ink-1000">
        {score}
      </span>
    </div>
  )
}
